module.exports = __webpack_public_path__ + "static/assets/63ac0df0500c06fc9c428167967c1bc1.png";